import React, { useEffect, useState } from 'react';
import Iframe from 'react-iframe';
import { URL_MAP_DEFAULT } from '../../../service/Config';

export default function P220Map({ data }) {

    const [sentData, setSentData] = useState({
        contractNo: "",
        routeNo: 0
    })

    useEffect(() => {
        setSentData({
            contractNo: data.contractNo ? data.contractNo : "",
            routeNo: data.routeNo
        })
    }, [data])

    return (
        <>
            {
                (sentData.contractNo !== "") ? (
                    <Iframe
                        url={`${URL_MAP_DEFAULT()}/Map220?contractNo=${sentData.contractNo}&routeNo=${sentData.routeNo}&token=dev`}

                        width="100%"
                        height="600"
                        display="initial"
                        position="relative"
                    />
                ) : ('No Data')
            }
        </>
    )
}
